<template>
    <span
        v-if="tag === 'span'"
        :class="[
            needClass === false? '': 'cp status',
            themes? 'is-'+ themes: '',
            icon? 'icon-font '+ icon: '',
        ]"
    >
        {{ text }}
        <slot></slot>
    </span>
    <div
        v-else-if="tag === 'div'"
        :class="classArray"
    >
        {{ text }}
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            themes: {
                type: String,
                require: false,
                default: ''
            },
            text: {
                type: String,
                require: false,
                default: ''
            },
            icon: {
                type: String,
                require: false,
                default: ''
            },
            needClass: {
                type: Boolean,
                require: false,
                default: true
            },
            tag: {
                type: String,
                require: false,
                default: 'span'
            },
        },
        computed: {
            classArray: function(){
                let _needClass = this.needClass,
                    _themes = this.themes,
                    _icon = this.icon,
                    _text = this.text;

                let $result = []

                if( _needClass ) {
                    $result.push('cp status');
                }

                if( _icon ) {
                    $result.push('icon-font');
                    $result.push(_icon);

                    if( !_text ) {
                        $result.push('icon-font-only');
                    }
                }

                if( _themes ) {
                    $result.push('is-'+ _themes);
                }

                return $result;
            }
        }
    }
</script>

<style scoped lang="scss">
    $default: 'normal'; //預設的顏色組

    $color: map-get($colors, $default);
    $bg: map-get($color, 'background');
    $bd: map-get($color, 'border');
    $tx: map-get($color, 'text');

    .cp.status {
        color: $tx;
        position: relative;

        @each $key, $map in $colors {
            $tx: map-get($map, 'text');

            &.is-#{$key} {
                color: $tx !important;
            }
        }
    }

    span.cp.status, a.cp.status {
        display: inline-block;

        &.font {

            &::before {
                vertical-align: bottom;
            }
        }

        &.icon-font-only {

            &::before {
                margin-right: 0;
            }
        }
    }

    div.cp.status {
        padding: $interval-s $interval-m;
        border: $bd;
        border-radius: $border-radius;
        margin: 1px;
        background-color: $bg;
        border-color: $bd;
        color: $tx !important;

        &.font {
            padding-left: $interval-xl;

            &::before {
                position: absolute;
                left: 8px;
                top: 11px;
            }

            &::after {
                content: none;
            }
        }

        &::v-deep {

            @each $key, $map in $colors {
                $bg: map-get($map, 'background');
                $bd: map-get($map, 'border');
                $tx: map-get($map, 'text');

                &.is-#{$key} {
                    background-color: $bg;
                    border-color: $bd;
                    color: $tx !important;
                }
            }
        }
    }
</style>
